import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './UnloadingList.html?raw';
import on from 'dojo/on';
import WizardView from '../../../moreCore/UI/Wizard/WizardView';
import "../../../moreCore/UI/Wizard/WizardView";
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import "../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox";
import "../../../moreCore/UI/Edit/Edit";
import "../../../moreCore/UI/SearchSelect/SearchSelect";

import TiUnloadingForm from '../../TransportIntermodal/UnloadingForm';
import "../../TransportIntermodal/UnloadingForm";

class TiUnloadingListWizard extends compose(_WidgetBaseSP) {
    templateString: any = template;

    wizardContainer: HTMLElement;
    debugContainer: HTMLElement;

    navRow: HTMLElement;
    nav1: HTMLElement;
    nav2: HTMLElement;
    nav3: HTMLElement;
    nav4: HTMLElement;

    nav1Summary: HTMLElement;
    nav2Summary: HTMLElement;
    nav3Summary: HTMLElement;
    nav4Summary: HTMLElement;

    nav1Container: HTMLElement;
    nav2Container: HTMLElement;
    nav3Container: HTMLElement;
    nav4Container: HTMLElement;

    headlineNode: HTMLElement;

    sectionWizardFinished: HTMLElement;

    btnReturnToList: HTMLButtonElement;
    btnAnotherBooking: HTMLButtonElement;
    public embeddedMode: boolean = false;



    unloadingForm: MdsLax<InstanceType<typeof TiUnloadingForm>>;

    wizard: MdsLax<InstanceType<typeof WizardView>>;

    private setupWizard(embeddedMode: boolean = false): void {

        let pDivision = this.getUrlParameterValue("division");
        let pTerminal = this.getUrlParameterValue("terminal");

        let wizard = new WizardView();
        this.wizard = wizard;

        wizard.placeAt(this.wizardContainer, "first");

        on(wizard, "change", lang.hitch(this, this._onWizardEvent));
        on(wizard, "pageswitch", lang.hitch(this, this._onWizardEvent));

        this.unloadingForm = new TiUnloadingForm();
        if (pDivision && pTerminal) {
            console.log("pDisivion", pDivision, "pTerminal", pTerminal);
            this.unloadingForm.divisionID = pDivision;
            this.unloadingForm.terminalID = pTerminal;
        }
        this.unloadingForm.on("saved", lang.hitch(this, this._onSaved__UnloadingForm));
        this.unloadingForm.placeAt(this.debugContainer);
        //on(this.unloadingForm, "revisionCompleted", lang.hitch(this, this._onCompleted));

        wizard.setupNavigation(false, "none", "none");


        let index = -1;
        index = wizard.addPage(this.unloadingForm, this.unloadingForm.section1_bookingFilter, "changeStep1", "s1_bookingFilter_Valid", "s1_bookingFilter_Summary", "DIVISON & TERMINAL SECTION");

        index = wizard.addPage(this.unloadingForm, this.unloadingForm.selectAndMoveBookingSection, "changeStep2", "s2_bookingSelect_Valid", "s1_bookingSelect_Summary", "CHOOSE BOOKING");
        wizard.addPageRule(index, "switchToIfPreviousIsValid");

        if (embeddedMode) {
            wizard.hidePage(0);
            this.hideNode(this.navRow, true, true);
            this.hideNode(this.headlineNode);
            this.unloadingForm.hideNode(this.unloadingForm.navigationBar);
        }

    }

    private _onSaved__UnloadingForm() {
        this.emit("saved");
    }

    /*private _onCompleted() {
        this.sectionWizardFinished.scrollIntoView({ behavior: "smooth" });
    }*/

    _onWizardEvent(data: Wizard.WizardPageEntry) {
        let summary = this.wizard.getPageSummary(data.index);
        //console.debug("_onWizardEvent", data, summary);

        let navTarget = null;
        let target: HTMLElement = null;

        let currentPage = this.wizard.getCurrentSelectedPageIndex();

        switch (data.index) {
            case 0:
                target = this.nav1Summary;
                navTarget = this.nav1;
                break;

            case 1:
                target = this.nav2Summary;
                navTarget = this.nav2;
                break;

            case 2:
                target = this.nav3Summary;
                navTarget = this.nav3;
                break;

            case 3:
                target = this.nav4Summary;
                navTarget = this.nav4;
                break;
        }

        if (navTarget) {
            this.UiModder.domClass.remove(navTarget, "hoverDark");
        }

        let validPages = this.wizard.getValidPages(true);
        //validPages.sort() // TODO
        this.UiModder.domClass.toggle(this.nav1, "enabled", true);
        this.UiModder.domClass.toggle(this.nav2, "enabled", validPages.indexOf(0) != -1);

        this.UiModder.domClass.toggle(this.nav1, "hoverDark", currentPage != 0);
        this.UiModder.domClass.toggle(this.nav2, "hoverDark", currentPage != 1);

        this.UiModder.domClass.toggle(this.nav1, "selected", currentPage == 0);
        this.UiModder.domClass.toggle(this.nav2, "selected", currentPage == 1);


        if (target) {
            this.UiModder.domAttr.set(target, "innerHTML", summary);
        }

        // Navigation einblenden, wenn die erste Seite mit der Vorauswahl fertig ist:
        if (validPages.indexOf(0) != -1) {
            this.UiModder.domClass.remove(this.navRow, "w3-hide");
        } else {
            // ansonsten immer zurück zu Seite 1
            this.switchToPage(0);
        }

        // Navigation ausblenden, wenn Seite 4 (Buchung abgeschickt) fertig ist wird
        if (validPages.indexOf(3) != -1) {
            this.UiModder.domClass.add(this.navRow, "w3-hide");
            this.UiModder.domClass.toggle(this.sectionWizardFinished, "w3-hide", false);

        }


        if (validPages.length == 5) {
            //this._data = this.unloadingForm.getData();
            
        } else {
            this._data = null;
        }

    }

    private _data: any = null;

    
    private switchToPage(target: number) {
        if (this.wizard.getCurrentSelectedPageIndex() == target) {
            if (this.wizard.getValidPages().length == 4) {
                target = 3; // zur Buchungszusammenfassung zurück
            } else {
                target = 0;
            }
        }

        if (this.wizard.getPageSelectable(target)) {
            this.wizard.switchToPage(target);
        }
    }

    private _onClick_Nav1(evt: MouseEvent) {
        this.switchToPage(0);
    }

    private _onClick_Nav2(evt: MouseEvent) {
        this.switchToPage(1);
    }
    private _onClick_Nav3(evt: MouseEvent) {
        this.switchToPage(2);
    }
    private _onClick_Nav4(evt: MouseEvent) {
        this.switchToPage(3);
    }

    private _onClick_AnotherBooking(evt: MouseEvent) {
        location.reload();
    }

    private _onClick_ReturnToList(evt: MouseEvent) {
        location.href = window.appRoot + "TransportIntermodal/List";

    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setupWizard(this.embeddedMode);
    }
}

export default mdsWidget(TiUnloadingListWizard);